import { useEffect } from "react";

import { useRouter } from "next/router";

import useAppcues from "@/utils/useAppcues";

const AppcuesTrackingContainer = () => {
  const router = useRouter();
  const appcues = useAppcues();

  // For reference, refer to the official docs: https://docs.appcues.com/dev-installing-appcues/installation-overview-for-developers
  useEffect(() => {
    appcues?.page();
  }, [router.pathname]);

  useEffect(() => {
    appcues?.identify();
  }, [appcues]);
  return null;
};

export default AppcuesTrackingContainer;
